@if (stakedAsset$ | async; as stakedAsset) {
  <div class="card center-block">
    @if (!!stakedAsset.nextReward) {
      <div class="title-container">
        <div class="title">
          <!-- Specific copy for UK -->
          {{ "uk_finprom_staking_rewards_earned" | translate }}
        </div>
      </div>
      <div class="item">
        <span class="reward">{{
          stakedAsset.rewardsAmount?.totalCurrent.asset
          | convert_tradable_to_fiat: stakedAsset.id
          | fiat_precision_symbol: { id: defaultFiat.getId(), currencies: [defaultFiat], symbol: true }
        }}</span>
        <span class="reward-sub">{{
          stakedAsset.rewardsAmount?.totalCurrent.asset
          | tradable_precision_symbol: { id: stakedAsset.id, ignorePrecision: true, symbol: true }
        }}</span>
      </div>
      <div class="pt-5 justify-between">
        <div class="item">
          <span class="labels">{{ "last_month_text" | translate }}</span>
          <span class="amounts">{{
            stakedAsset.rewardsAmount?.totalLastMonth.asset
            | convert_tradable_to_fiat: stakedAsset.id
            | fiat_precision_symbol
            : { id: defaultFiat.getId(), currencies: [defaultFiat], symbol: true }
          }}</span>
        </div>
        <div class="item">
          <!-- Specific copy for UK -->
          <span class="labels">{{ "uk_finprom_rewards_payout" | translate }}</span>
          <span class="amounts">{{ stakedAsset.rewardIntervals | stake_reward_interval }}</span>
        </div>
      </div>
      <a class="button-weight" (click)="openRewardsFlow.emit(stakedAsset.id)">{{
        "tradable_you_own_view_related_transactions" | translate
      }}</a>
      <staking-reward-actions
        class="flex-center-horizontal"
        [stakedAsset]="stakedAsset"
        (flowClick)="openModalFlow.emit($event)">
      </staking-reward-actions>
    } @else {
      <bp-content-load-indicator></bp-content-load-indicator>
    }
  </div>
}
